import { NavLink } from 'react-router-dom'
import type { SubTab } from '../nav'
import type { Badges } from './Sidebar'

/**
 * Barra de sub-pestañas bajo el header.
 *
 * Es lo que permitió pasar de 18 ítems planos en el sidebar a 6 módulos: cada
 * pestaña es una ruta que ya existía y conserva su contenido íntegro. El ítem
 * del sidebar sigue activo mientras cualquiera de sus pestañas lo esté (lo
 * resuelve `nav.resolveScreen`).
 */
export default function SubTabs({ tabs, badges }: { tabs: SubTab[]; badges: Badges }) {
  if (tabs.length <= 1) return null

  return (
    // Con la ventana angosta (desde 768, DEF-031) las cinco pestañas de
    // Operación no entran: se desplazan por dentro en vez de recortarse.
    <div className="scrollbar-thin flex shrink-0 items-center gap-1 overflow-x-auto border-b border-surface-border bg-white px-7">
      {tabs.map((tab) => {
        const count = tab.badge ? badges[tab.badge] : 0
        return (
          <NavLink
            key={tab.to}
            to={tab.to}
            className={({ isActive }) =>
              `flex shrink-0 items-center gap-1.5 whitespace-nowrap border-b-2 px-[15px] py-3 text-body font-bold transition-colors ${
                isActive
                  ? 'border-brand text-ink'
                  : 'border-transparent text-ink-faint hover:text-ink-muted'
              }`
            }
          >
            {tab.label}
            {count > 0 && (
              <span className="rounded-chip bg-danger-light px-1.5 py-px text-[10px] font-bold text-danger">
                {count}
              </span>
            )}
          </NavLink>
        )
      })}
    </div>
  )
}
